import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';

export interface University {
    id: string;
    name: string;
}

export interface UniversityReponse {
    universities: University[]
}


export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath('/api/user'),
        prepareHeaders: prepareAuthHeaders,
        credentials: 'include',
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        findUniversities: builder.mutation<any, string>({
            query: (name) => ({
                url: 'universities',
                method: 'GET',
                params: { name },
            }),
            transformResponse: (response: UniversityReponse) => {
                return response.universities;
            }
        }),
        getInfos: builder.query<any, null>({
            query: (name) => ({
                url: '',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.user;
            }
        }),
        updateInfos: builder.mutation<any, any>({
            query: (infos) => ({
                url: '',
                method: 'PATCH',
                body: infos,
            })
        }),
        inviteSudent: builder.mutation<any, any>({
            query: (body) => ({
                url: 'prof/invite',
                method: 'PUT',
                body,
            })
        }),
        getInvitedStudents: builder.query<any, any>({
            query: () => ({
                url: 'prof/invited',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.invited_users;
            }
        }),

    })
});

export const { useFindUniversitiesMutation, useGetInfosQuery, useUpdateInfosMutation, useInviteSudentMutation, useGetInvitedStudentsQuery } = userApi;

export const { endpoints: { getInfos } } = userApi;